import React from 'react';
import {InstagramOutlined,ContactsOutlined,CodepenOutlined, UnorderedListOutlined } from '@ant-design/icons';


export const WeekData =[
    {title:'Events',Icon:<UnorderedListOutlined />,value:'8',background:'#dd4b39',url:'/events' },
    {title:'Sessions',Icon:<CodepenOutlined />,value:'8',background:'#0073b7',url:'/sessions' },
    {title:'Users',Icon:<ContactsOutlined />,value:'5',background:'#00a65a',url:'/users' },
    {title:'Machines',Icon:<InstagramOutlined />,value:'9',background:'#00c0ef',url:'/machines' },
    {title:'Countries',Icon:<InstagramOutlined />,value:'3',background:'#00c0ef',url:'/countries' },
    {title:'Companies',Icon:<InstagramOutlined />,value:'2',background:'#00c0ef',url:'/companies' },
    {title:'Configurations',Icon:<InstagramOutlined />,value:'2',background:'#00c0ef',url:'/configurations' },
    
]